module.exports = __webpack_public_path__ + "img/rightImg.fa2997fa.png";